import { uniqBy } from "lodash";
import { useMemo, useState } from "react";

/**
 * @description to handle the search form MultiSelect
 * @summary  -  while search prev Record get Vanished  to handle the scenario created this hook
 *
 * @param data
 * @see - data must have first key of `value`
 *
 * @returns merged prev and Cur Data
 *
 * @author rajkumar rathod
 */
export const useMultiSelectDataController = <T extends any[]>(
  data?: T,
  prefillData?: any[]
): any => {
  const [prevData, setPrevData] = useState<any[]>(prefillData ?? []);
  /** find key and */
  const keys =
    data && data?.length > 0 ? (Object.keys(data[0]) as (keyof T)[]) : [];

  /** merged prevData and curData with caching */
  const mergedUniqData = useMemo(() => {
    /** remove duplication of data using key of data */
    const mergedData = uniqBy([...(prevData ?? []), ...(data ?? [])], keys[0]);

    // set curData to prevData
    setPrevData(mergedData);

    return mergedData;
  }, [data]);

  return mergedUniqData;
};
